import React, { useContext } from 'react'
import { Navbar, Nav, Button, Container } from 'react-bootstrap'
import { FaFileAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import { AuthContext } from '../components/AuthContext'
const TopNav = (props) => {
    const [currentUser, setCurrentUser] = useContext(AuthContext)
    return (
        <header>
            <Navbar expand="lg" className="NavbarFixed">
                <Container>
                    <Navbar.Brand className="BrandNavbar" href="https://fresume.in/"> <FaFileAlt className="brandIcon" /> Fresume</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link className="NavEach" href="/team">Team</Nav.Link>
                            <Link to="/login">
                                <Button className="btnCreate" variant="outline-primary" >
                                    {currentUser.user ? "Take me to Dashboard" : "Create Your Free Page Now"}

                                </Button>
                            </Link>

                        </Nav>

                    </Navbar.Collapse>
                </Container>

            </Navbar>
            {/* <Main /> */}
        </header>

    )
}

export default TopNav;